// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2gMQr","left":"styles_left__so5g9","desktopActions":"styles_desktopActions__1pW0m","title":"styles_title__2FmAC"};